import { GenericEvents } from '@newrelic/browser-agent/features/generic_events';
import { MicroAgent } from '@newrelic/browser-agent/loaders/micro-agent'
const accountID = process.env.REACT_APP_ACCOUNT_ID;
const trustKey = process.env.REACT_APP_TRUST_KEY;
const agentID = process.env.REACT_APP_AGENT_ID;
const licenseKey = process.env.REACT_APP_LICENSE_KEY;
const applicationID = process.env.REACT_APP_APPLICATION_ID;

const options:any = {
  info: {
    beacon: "bam.nr-data.net",
    errorBeacon: "bam.nr-data.net",
    licenseKey: licenseKey,
    applicationID: applicationID,
  },
  loader_config: {
    accountID: accountID,
    trustKey: trustKey,
    agentID: agentID,
    licenseKey: licenseKey,
    applicationID: applicationID,
  },
  init: {
    distributed_tracing: { enabled: true },
    privacy: { cookies_enabled: true },
  },
}
export const microAgent = new MicroAgent(options)